import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

export default () => {
    const postLoop = document.querySelector("#post-loop");

    if (postLoop) {
        const posts = postLoop.querySelectorAll(".post-card");

        if (!posts) return;

        const offsetPosition = window.innerWidth < 1023 ? 25 : 50;

        const tween = gsap.from(".post-card", {
            x: offsetPosition,
            y: offsetPosition,
            opacity: 0,
            duration: 0.5,
            stagger: 0.2,
        });
        ScrollTrigger.create({
            trigger: postLoop,
            start: "top bottom",
            end: "bottom top",
            animation: tween,
            once: true,
        });
    }
};
